import { render, staticRenderFns } from "./resume-detail-contrats.vue?vue&type=template&id=647cd45e&scoped=true"
import script from "./resume-detail-contrats.vue?vue&type=script&lang=js"
export * from "./resume-detail-contrats.vue?vue&type=script&lang=js"
import style0 from "./resume-detail-contrats.vue?vue&type=style&index=0&id=647cd45e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647cd45e",
  null
  
)

export default component.exports